export default __webpack_public_path__ + "static/media/correspondent17.8a5c9745.png";